/**
 *  Bug #473 
 * @Author Anupama P 
 * @Date 13 Jul 2021 
 * */

import { AppointmentsVirtualCheckIn, Blog, BlogDetailsInfo, BlogDetailsInfo2, BlogDetailsInfo3, BlogDetailsInfo4, Personalccda, QrcodeInfo, PatientQrDemographic } from "config/routersConstants";
import React from "react";/* Bug #473 @Author Jithin Kuriakose @Date 01 July 2021 */

//pages

//pharmacy


/* End  */

/**
  * Bug #455
  * @Author Aby Joseph
  * @Date 25 June 2021
*/
const Qrcode = React.lazy(() => import("client/components/pages/qrcode"));
/* End  */
const PatientQrCcda = React.lazy(() => import("client/components/patients/patient-qr-data/patient-qr-ccda"));
const PatientQrDemographics = React.lazy(() => import("client/components/patients/patient-qr-data/patient-qr-demographics"));

export const NormalRouting = [
  
  /**
* Bug #518 - remove unused routing path
* @Author Liya Baby 
* @Date 26 July 2021
*/
  //{ path: "/pages/calendar", component: Calendar },
  //{ path: "/terms", component: Terms },
  //{ path: "/privacy-policy", component: Policy },
  { path: QrcodeInfo.path, component: Qrcode, label: QrcodeInfo.label },

  /**
 *  Bug #610 
 * @Author Anupama P 
 * @Date 21 Sep 2021 
 * */
  { path: Personalccda.path, label:Personalccda.label, component: PatientQrCcda ,layoutType:"public"},
  { path: PatientQrDemographic.path, label:PatientQrDemographic.label, component: PatientQrDemographics ,layoutType:"public"},/** Bug #610  @Author Linda Susan Raju  @Date 21 Sep 2021 */
]